// extracted by mini-css-extract-plugin
export default {"subHeader":"style--subHeader--f7631d","bolded":"style--bolded--090e79"};